import awakingImg from '@/static/assets/customer_reviews/pics/tweet_face_awaking.png';
import brentImg from '@/static/assets/customer_reviews/pics/tweet_face_brent.png';
import jakobImg from '@/static/assets/customer_reviews/pics/tweet_face_jakob.png';
import jenniferImg from '@/static/assets/customer_reviews/pics/tweet_face_jennifer.png';
import mariaImg from '@/static/assets/customer_reviews/pics/tweet_face_maria.png';
import rashiqImg from '@/static/assets/customer_reviews/pics/tweet_face_rashiq.png';

export const tweets = [
  {
    name: 'Jakob Wahlers',
    handle: 'jakobwahlers',
    img: jakobImg,
    text: 'Dikke like voor <span class="primary">@Lemonade_Inc</span>! Nog nooit eerder ben ik een verzekering tegengekomen die simpel, eerlijk en ook nog eens transparant is. <span class="primary">#verzekering #digitalisering #papierloos</span>',
  },
  {
    name: 'Rashiq in SF',
    handle: 'rashiq',
    img: rashiqImg,
    text: '<span class="primary">@Lemonade_Inc</span> - wow dit was de beste ervaring die ik ooit heb gehad met een verzekering. Geen twijfel over mogelijk! Ik ben gek op jullie app.',
  },
  {
    name: 'Brent',
    img: brentImg,
    handle: 'goforbrent',
    text: '<span class="primary">@Lemonade_Inc</span> was de makkelijkste verzekering die ik ooit heb afgesloten. “Traditionele” verzekeringsmaatschappijen moeten zich echt meer aan de huidige eeuw aanpassen!!!',
  },
  {
    name: 'Jennifer Troyer',
    img: jenniferImg,
    handle: 'jennifer_troyer',
    text: 'Ik hoorde vanochtend over <span class="primary">@Lemonade_Inc</span> en ze hebben nu een nieuwe klant. Dit was ongetwijfeld de fijnste onboarding-ervaring die ik ooit heb meegemaakt. Ik zou het eigenlijk nog een keertje willen doen... Goed werk!',
  },
  {
    name: 'Maria Salamanka',
    handle: 'MariaSalamankaM',
    img: mariaImg,
    text: 'Ik ben altijd teleurgesteld in hoe verzekeraars met hun klanten ‘vechten’ als er een claim wordt ingediend. Maar ik heb zojuist mijn eerste goede ervaring gehad. Buitengewoon snelle and geweldige klantervaring met <span class="primary">@Lemonade_Inc</span>.',
  },
  {
    name: 'AWaking Dream',
    handle: 'AWaking_Dream',
    img: awakingImg,
    text: 'Eens in de 2-3 jaar, kom ik een app/bedrijf tegen die gewoon de spijker op de kop slaat. De hele ervaring, de prijs, de klantenservice - <span class="primary">@Lemonade_Inc</span> heeft het echt allemaal en ik vind het geweldig!',
  },
];
